import React from "react";

// MUI
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

// Config
import { appConfig } from "../../../utility/config";

type Props = {
  title: string;
  //onClick: (val: string) => void;
  filterKey: string;
  count: string;
  value: string;
  bgColor: string;
};

const HeaderCard = ({
  title,
  //onClick,
  filterKey,
  count,
  value,
  bgColor,
}: Props) => {
  return (
    <Card
      //onClick={() => onClick(filterKey)}
      sx={{
        backgroundColor: bgColor,
        flex: 1,
        cursor: "pointer",
        height: `${appConfig.headerHeight - 16}px`,
      }}
    >
      <CardContent
        sx={{
          padding: "5px",
          "&.MuiCardContent-root:last-child": {
            paddingBottom: 0,
          },
        }}
      >
        <Stack>
          <Typography
            variant="caption"
            sx={{
              fontWeight: 600,
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {title}
          </Typography>
          <Typography variant="caption">#: {count}</Typography>
          <Typography variant="caption">Cr: {value}</Typography>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default HeaderCard;
